<template>
  <section class="kv">
    <div class="kv-content">
      <h1 class="kv-title">FiveStones Data-driven Creative ROI Calculator</h1>
      <button class="btn kv-btn use-calculator-banner" @click.prevent="scrollToForm">
        Use DDC ROI Calculator
      </button>
      <div class="kv-img">
        <img src="./../assets/kv-img.svg" alt="" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Kv',
  props: ['scrollToForm'],
  data() {
    return {}
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Kv.vue